export default [
    {
        quote: 'We chose Grasshopper because we need all of our customer communications to be pushed to the same place.',
        cite: 'Jonathan Heuer, Home Maintenance',
        author: 'Jonathan Heuer',
        src: 'Jonathan-Heuer.png'
    },
    {
        quote: 'Having a phone number on our site increased conversion of site visitors to sign up and paid users.',
        cite: 'Allan Branch, Accountant',
        author: 'Allan Branch',
        src: 'Allan-Branch.png'
    },
    {
        quote: 'Grasshopper lets my company scale like never before. Now, my entire team is accessible to our customers since all employees can answer calls despite their location or time zone.',
        cite: 'Glenda Dorn, Retail Management',
        author: 'Glenda Dorn',
        src: 'Glenda-Dorn.png'
    },
    {
        quote: 'Grasshopper has helped me transition from being perceived as a small "mom and pop shop" to a professional business, which is a top priority for the success of my company.',
        cite: 'Jose Greer, Personal Chef',
        author: 'Jose Greer',
        src: 'Jose-Greer.png'
    }
];
